import React, { Component } from 'react';
import { inject, observer } from "mobx-react";

import BrandColumn from './brand-column';
import BrandImages from './brand-images';
import BlockBrandNavigation from './content/block-brand-navigation';

const BrandBlock = inject("stores") (
    observer (
        class BrandBlock extends Component {
            constructor(props) {
                super(props);
                this.props = props;
                this.urlAPI = process.env.REACT_APP_URL_API;
                this.storeUi = this.props.stores.storeUi;

                this.state = {
                    brand_data: {}
                }
            }

            componentDidMount = async() => {
                const brand_data = await this.storeUi.getBrandData(this.props.item.name);
                this.setState({
                    brand_data: brand_data
                })
            }

            componentDidUpdate = async() => {

            }

            viewLookbook = () => {
                let url = '';
                this.location.push(url);
            }

            handleBack = () => {
                this.props.handleBack();
            }

            render() {
                return (
                    <div className="block--brand">                    
                        <div className="block--brand__columns">
                            <div className="block--brand__column block--brand__column--text">
                                <div className="block--brand__header">
                                    <img src={this.urlAPI + "/adam/public/images/brands/logo-" + this.props.item.name + "-white.png"} />
                                </div>
                                {this.state.brand_data && Object.keys(this.state.brand_data).map((key, i) => (
                                    <BrandColumn
                                        name = {this.props.item.name}
                                        data = {this.state.brand_data[key].sections}
                                    />
                                ))}
                                <div className="block--brand__footer">
                                    <BlockBrandNavigation
                                        section = {this.props.section}
                                        brand = {this.props.brand}
                                        url = {this.props.item.url}
                                        lookbook = {this.props.item.lookbook}
                                        handleBack = {this.handleBack}
                                        
                                    />
                                </div>
                            </div>
                            <div className="block--brand__column block--brand__column--previews">
                                {this.state.brand_data && Object.keys(this.state.brand_data).map((key, i) => (
                                    <BrandImages
                                        name = {this.props.item.name}
                                        data = {this.state.brand_data[key].sections}
                                        large = {this.state.brand_data[key].large}
                                    />
                                ))}
                            </div>
                        </div>
                        
                    </div>
                );
            }
        }
    )
)

export default BrandBlock;
